import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { deleteGroup, resetGroupState } from "../actions/action_deleteGroup";
import { fetchUserData } from "../../../global/app/actions/actions_fetchUsers";
import Modal from "react-modal";
import { MdClose } from "react-icons/md";

const DeleteNetworkButton = ({ currentUser }) => {
  const [showModal, setShowModal] = useState(false);
  const dispatch = useDispatch();
  const { data, error, loading, initial } = useSelector(
    (state) => state.deleteGroupReducer
  );

  const deleteUsersGroup = () => {
    dispatch(deleteGroup(currentUser));
  };

  const toggleModal = () => {
    setShowModal(!showModal);
  };

  useEffect(() => {
    if ((!!data || !!error) && !loading && !initial) {
      setShowModal(false);
      if (!!data && !error) dispatch(fetchUserData());
      dispatch(resetGroupState());
    }
  }, [data, loading, error, initial]);

  const isDeletable = !currentUser.Group.Invitation?.find(
    (inv) => inv.invitation_status === "Accepted"
  );
  return (
    <>
      {isDeletable && (
        <div>
          <button
            onClick={toggleModal}
            className="usa-button usa-button--outline modal-button"
          >
            <span className="button-text">Delete Network</span>
          </button>
        </div>
      )}
      <Modal
        isOpen={showModal}
        onRequestClose={toggleModal}
        className="network-modal"
        overlayClassName="Overlay"
      >
        <button className="modal-exit-x" onClick={toggleModal} type="button">
          <MdClose className="close-icon" />
        </button>
        <div className="network-modal-first-page">
          <h3>Delete Network</h3>
          <p className="modal-body-text">
            Deleting your network will automatically remove you, and your cases
            from the network. Your cases will be returned to you as an
            individual filer
          </p>
        </div>
        <div className="float-right">
          <button
            className="usa-button usa-button--outline"
            onClick={toggleModal}
          >
            Close
          </button>
          <button
            className="usa-button usa-button--primary"
            onClick={deleteUsersGroup}
          >
            Continue
          </button>
        </div>
      </Modal>
    </>
  );
};

export default DeleteNetworkButton;
